import React from 'react';
import styles from './landing-faq.module.scss';
import { OfferDropdown } from 'shared/ui';

const faqItems = [
  {
    title: 'Можно ли перенести базу клиентов из другой программы?',
    description:
      'Да, поддерживается импорт CSV/Excel из Dikidi, YClients и других систем.',
  },
  {
    title: 'Как подключить VK-бот для напоминаний?',
    description:
      'VK-бот подключается автоматически после создания точки. Настройка занимает 5 минут.',
  },
  {
    title: 'Работает ли система для нескольких филиалов?',
    description:
      'Да, вы можете управлять неограниченным количеством филиалов из одного аккаунта.',
  },
  {
    title: 'Есть ли интеграция с Яндекс Картами?',
    description:
      'Да, подключаем бесплатно по запросу на integration@book-up.ru. Настройка за 1-2 дня.',
  },
  {
    title: 'Сколько времени занимает настройка?',
    description:
      'В среднем 15 минут. Добавьте услуги, сотрудников и график работы.',
  },
  {
    title: 'Могу ли я попробовать бесплатно?',
    description: '30 дней, 2 сотрудника, все функции. Без привязки карты.',
  },
];

export const LandingFAQ: React.FC = () => {
  return (
    <div className={styles.faq_outer}>
      <div className={styles.landing_faq}>
        <h2 className={styles.landing_faq__title}>Часто задаваемые вопросы</h2>
        <div className={styles.landing_faq__items}>
          {faqItems.map((item, index) => (
            <OfferDropdown
              key={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
